module.exports = __webpack_public_path__ + "img/USDT.4a3ecff3.svg";